import React from "react";

const Wrike = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M9.518 15.175c1.555 0 2.28.236 3.392 1.33l6.008 5.846c.177.168.212.236.247.353.018.034.018.085.018.118 0 .034 0 .085-.018.118-.035.101-.07.169-.247.354L14.8 27.303c-.177.168-.248.202-.354.236-.035.017-.088.017-.123.017s-.088 0-.124-.017c-.106-.034-.176-.068-.353-.236L2.185 16c-.336-.32-.212-.825.353-.825h6.98ZM26.5 8c-1.555 0-2.28.27-3.393 1.364l-6.025 5.845c-.177.169-.212.236-.247.354-.018.017-.018.084-.018.118 0 .034 0 .084.018.118.035.1.07.168.247.354l4.117 3.992c.177.168.247.202.353.235.036.017.089.017.124.017.036 0 .089 0 .124-.017.106-.033.177-.067.353-.235L33.815 8.842c.336-.32.212-.842-.353-.842H26.5Z"
            fill="#08CF65"
        />
    </svg>
);

export default Wrike;
